var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwoFa(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 30.5V69.5H69.63V30.5L35.5 1.64L2 30.5Z",
    stroke: "url(#paint0_linear_6539_98274)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30.5L24.58 49.74",
    stroke: "url(#paint1_linear_6539_98274)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.58 30.5L47 49.74",
    stroke: "url(#paint2_linear_6539_98274)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 40V12H13.5V40",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 40V12H13.5V40",
    stroke: "url(#paint3_linear_6539_98274)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26C63.9036 26 69.5 20.4036 69.5 13.5C69.5 6.59644 63.9036 1 57 1C50.0964 1 44.5 6.59644 44.5 13.5C44.5 20.4036 50.0964 26 57 26Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26 31C27.6569 31 29 29.6569 29 28C29 26.3431 27.6569 25 26 25C24.3431 25 23 26.3431 23 28C23 29.6569 24.3431 31 26 31Z",
    fill: "url(#paint4_linear_6539_98274)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36 31C37.6569 31 39 29.6569 39 28C39 26.3431 37.6569 25 36 25C34.3431 25 33 26.3431 33 28C33 29.6569 34.3431 31 36 31Z",
    fill: "url(#paint5_linear_6539_98274)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M46 31C47.6569 31 49 29.6569 49 28C49 26.3431 47.6569 25 46 25C44.3431 25 43 26.3431 43 28C43 29.6569 44.3431 31 46 31Z",
    fill: "url(#paint6_linear_6539_98274)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2 69.5L35.82 39.9L69.63 69.5",
    stroke: "url(#paint7_linear_6539_98274)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57 15.6667V17.4444M51.75 21H62.25C63.2165 21 64 20.2041 64 19.2222V13.8889C64 12.907 63.2165 12.1111 62.25 12.1111H51.75C50.7835 12.1111 50 12.907 50 13.8889V19.2222C50 20.2041 50.7835 21 51.75 21ZM60.5 12.1111V8.55556C60.5 6.59188 58.933 5 57 5C55.067 5 53.5 6.59188 53.5 8.55556V12.1111H60.5Z",
    stroke: "url(#paint8_linear_6539_98274)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6539_98274",
    x1: 11.7207,
    y1: 4.5553,
    x2: 51.3769,
    y2: 49.5725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6539_98274",
    x1: 5.24551,
    y1: 31.3266,
    x2: 16.1183,
    y2: 45.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6539_98274",
    x1: 50.2455,
    y1: 31.3266,
    x2: 61.1183,
    y2: 45.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6539_98274",
    x1: 19.8243,
    y1: 13.2029,
    x2: 33.8704,
    y2: 38.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6539_98274",
    x1: 23.8624,
    y1: 25.2578,
    x2: 27.3672,
    y2: 29.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6539_98274",
    x1: 33.8624,
    y1: 25.2578,
    x2: 37.3672,
    y2: 29.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6539_98274",
    x1: 43.8624,
    y1: 25.2578,
    x2: 47.3672,
    y2: 29.2499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6539_98274",
    x1: 11.7207,
    y1: 41.1716,
    x2: 23.397,
    y2: 71.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6539_98274",
    x1: 52.0123,
    y1: 5.68737,
    x2: 61.4376,
    y2: 15.0813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoFa);
export default __webpack_public_path__ + "static/media/twoFA.e1fe4b1c.svg";
export { ForwardRef as ReactComponent };